module.exports = __webpack_public_path__ + "madrid-6c562cd61cebb6abb202faa0bc798456.bundle.jpg";